<template>
    <div>
        <!-- <img :src="hssrc" object-fit="fill" /> -->
        <el-image 
            :src="hssrc" 
            fit="fill" 
            :lazy="true" 
            style="width: 100%; height: 100%;"            
            :alt="alt"
            :referrer-policy="referrerPolicy"
            :scroll-container="scroll"
            :preview-src-list="previewSrcList"
            :z-index="zIndex"
            :initial-index	="initialIndex"

            ></el-image>
    </div>
</template>


<style>

</style>

<script>
export default {
    name:'hsimage',
    props:{
        src:String,
        alt:String,
        referrerPolicy:String,
        lazy:Boolean,
        scroll:String,
        previewSrcList:Array,
        zIndex:Number,
        initialIndex:Number
    },
    components:{
    },
    data(){
        return {
            hssrc: ''
        }
    },
    beforeMount(){
        // let baseapi = process.env.BASE_API
        // if(baseapi !=  undefined){
        //     let url = 'https://hansvision.com' // baseapi.substring(0,baseapi.indexOf('/api'))
		// 	//this.hssrc = url+this.src
        // }else {
        //     this.hssrc = this.src
        // }
        
        this.hssrc = this.src

    },
    mounted(){
    },
    methods:{
    },
    watch:{
        src:{
            handler(newval){
                this.hssrc = newval
            },
            immediate:true
        }
    }
        
}
</script>



// WEBPACK FOOTER //
// src/components/common/hsimage.vue